export const ID = 'id';
export const ZIPCODE = 'zipcode';
export const WORKER_ID = 'workerId';
export const CITY = 'city';
export const COUNTRY = 'country';